export const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const initializeStorage = (storageType) => {
    if (!isBrowser)
        return;
    try {
        const storage = window[storageType];
        return storage && typeof storage.getItem === 'function' ? storage : undefined;
    }
    catch {
        return;
    }
};
const webApi = {
    crypto: isBrowser ? crypto : globalThis.crypto,
    localStorage: initializeStorage('localStorage'),
    sessionStorage: initializeStorage('sessionStorage'),
};
export default webApi;
